(() => {
  const initSlider = (section) => {
    if (!section?.classList.contains("logo-list-section")) return;

    const slider = section.querySelector(".js-slider-logos");
    if (!slider) return;

    const sliderWrapper = slider.querySelector(".js-slider-logos-wrapper");
    const logoSlides = slider.querySelectorAll(".swiper-slide");

    if (!sliderWrapper || !logoSlides.length) return;

    window.theme.initContinuousMarquee(slider, {
      speed: +slider.dataset.duration || 4000,
      gap: +slider.dataset.gap || 0,
      stopOnHover: slider.dataset.stopOnHover === "true",
      marqueeCopies: +slider.dataset.marqueeCopies || 2,
    });
  };

  const initAll = (root = document) => {
    const sections =
      root instanceof Element && root.matches(".logo-list-section")
        ? [root]
        : root.querySelectorAll(".logo-list-section");

    sections.forEach(initSlider);
  };

  const scriptSection = window.theme.getSectionFromCurrentScript(
    "logo-list-section"
  );

  if (scriptSection) {
    initSlider(scriptSection);
  } else {
    initAll();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAll(event.target);
  });
})();
